import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  adMedia: {
    height: ({ height }) => height,
    maxHeight: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: '100%'
    }
  }
})

export default useStyles
